/**
 * Offline tile pack status for Greater Havana (PMTiles / MapTiler offline style).
 */

export const HAVANA_OFFLINE_PACK_META_KEY = 'alea.map.havanaPack';
export const HAVANA_OFFLINE_CACHE_NAME = 'alea-havana-tiles-v1';

export type HavanaPackStatus = 'unavailable' | 'ready' | 'downloading' | 'error';

export type HavanaPackMeta = {
  url: string;
  savedAt: number;
  bytes?: number;
  status: HavanaPackStatus;
};

export function parseHavanaPackMeta(raw: unknown): HavanaPackMeta | null {
  if (!raw || typeof raw !== 'object') return null;
  const r = raw as Record<string, unknown>;
  const url = String(r.url ?? '').trim();
  if (!url) return null;
  const status = String(r.status ?? 'ready') as HavanaPackStatus;
  return {
    url,
    savedAt: Number(r.savedAt ?? Date.now()),
    bytes: r.bytes != null ? Number(r.bytes) : undefined,
    status: ['unavailable', 'ready', 'downloading', 'error'].includes(status)
      ? status
      : 'ready',
  };
}

export function readHavanaPackMeta(
  storage?: Pick<Storage, 'getItem'> | null,
): HavanaPackMeta | null {
  try {
    const store = storage ?? (typeof localStorage !== 'undefined' ? localStorage : null);
    if (!store) return null;
    const raw = store.getItem(HAVANA_OFFLINE_PACK_META_KEY);
    if (!raw) return null;
    return parseHavanaPackMeta(JSON.parse(raw));
  } catch {
    return null;
  }
}

export function writeHavanaPackMeta(
  meta: HavanaPackMeta,
  storage?: Pick<Storage, 'setItem'> | null,
): void {
  try {
    const store = storage ?? (typeof localStorage !== 'undefined' ? localStorage : null);
    store?.setItem(HAVANA_OFFLINE_PACK_META_KEY, JSON.stringify(meta));
  } catch {
    // ignore
  }
}
